import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FOUNDERS } from "../data/site";
import { Reveal } from "./Reveal";

export const FoundersPreview = () => (
  <section className="mx-auto max-w-[1400px] px-6 py-28 lg:px-12 lg:py-40" data-testid="founders-preview">
    <Reveal>
      <p className="font-mono-label text-xs text-copper">03 — The people</p>
      <div className="mt-6 flex flex-wrap items-end justify-between gap-8">
        <h2 className="font-display max-w-2xl text-4xl font-semibold uppercase leading-tight text-zinc-100 sm:text-5xl lg:text-6xl">
          Faces behind<br />the <span className="text-copper">metal.</span>
        </h2>
        <Link
          to="/founders"
          data-testid="founders-preview-link"
          className="group flex items-center gap-2 border border-zinc-700 px-6 py-3 font-mono-label text-[11px] text-zinc-200 transition-colors duration-300 hover:border-copper hover:text-copper-light"
        >
          Meet the founders
          <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>
    </Reveal>

    <div className="mx-auto mt-16 grid max-w-4xl grid-cols-1 gap-6 sm:grid-cols-2">
      {FOUNDERS.map((f, i) => (
        <Reveal key={f.id} delay={i * 0.12}>
          <div className="group relative border border-zinc-800 bg-surface" data-testid={`founder-preview-${f.id}`}>
            <div className="h-80 overflow-hidden">
              <img
                src={f.img}
                alt={`${f.name}, ${f.role} of Omkaar Metals`}
                className="clip-corner-sm h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <p className="font-stencil text-[10px] text-copper">Founder file // {f.id}</p>
              <p className="font-display mt-2 text-xl font-semibold uppercase text-zinc-100">{f.name}</p>
              <p className="font-mono-label mt-1 text-[10px] text-zinc-500">{f.role}</p>
            </div>
            <span className="absolute right-4 top-4 border-2 border-copper/70 bg-black/60 px-2 py-1 font-stencil text-[10px] text-copper backdrop-blur-sm">
              10+ YRS
            </span>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
